import type { ParticipantSummary } from '@proaxiv/server-api'
import { apiPresStatusToUiStatus } from './participantMappers'

// ── Presentation eligibility ──────────────────────────────────────────────────

export const PRES_ELIGIBLE = new Set(['SPEAKER', 'HOST'])

/**
 * Whether a participant can currently be asked to submit (or have a presentation uploaded on
 * their behalf) — i.e. an eligible Speaker/Host who hasn't already gotten one accepted.
 * Shared by the desktop "Ask" icon in `AcceptedRowActions` and the Ask/Upload buttons in
 * `PresentationRowActions`, since both apply under the exact same condition.
 */
export function canAskForPresentation(reg: ParticipantSummary): boolean {
  const isEligible = PRES_ELIGIBLE.has(reg.role ?? '')
  const status = apiPresStatusToUiStatus(reg.presentation?.status)
  return isEligible && (status === 'none' || status === 'reminder_sent' || status === 'rejected')
}

/**
 * Whether a participation reminder can be sent to this participant. Reminders are about general
 * participation, not just the presentation workflow, so they stay available regardless of
 * presentation status (including once a presentation has been accepted).
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept for a stable, typed API
export function canSendReminder(_reg: ParticipantSummary): boolean {
  return true
}

// ── Attendance eligibility ────────────────────────────────────────────────────

/**
 * Whether a participant can currently be manually marked as attended (bypassing the check-in
 * kiosk QR scan) — i.e. they haven't already checked in. Shared by the per-row "Set as attended"
 * button in `PresentationRowActions` and the bulk toolbar action in `AcceptedParticipantsTab`,
 * since both apply under the exact same condition.
 */
export function canMarkAttended(reg: ParticipantSummary): boolean {
  return !reg.attendedAt
}
